import { render } from "./BoardNoticeManageListPage.vue?vue&type=template&id=7f258a2e&lang=true"
import script from "./BoardNoticeManageListPage.vue?vue&type=script&lang=js"
export * from "./BoardNoticeManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__